import { render, staticRenderFns } from "./local_item.vue?vue&type=template&id=123d5e9e&scoped=true"
import script from "./local_item.vue?vue&type=script&lang=ts"
export * from "./local_item.vue?vue&type=script&lang=ts"
import style0 from "./local_item.vue?vue&type=style&index=0&id=123d5e9e&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "123d5e9e",
  null
  
)

/* custom blocks */
import block0 from "./local_item.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports